<template>
  <el-dialog :visible="visible" class="no-head">
    <div class="pop-up">
      <div class="box-content" :style="{ width: width }">
        <div class="pop-up-title">
          <div style="flex: 1;font-weight: bold;" v-if="showTitle">
            {{ title }}
          </div>
          <div style="flex: 1;font-weight: bold;" v-else>
            <slot name="title" />
          </div>
          <i class="el-icon-close" @click="bindCancel"></i>
        </div>
        <div class="pop-up-content">
          <slot />
        </div>
        <div class="pop-up-foot" v-if="showFoot">
          <div class="pop-up-foot-left">
            <slot name="footLeft" />
          </div>
          <div>
            <el-button size="small" type="primary" @click="bindConfirm">确 定</el-button>
            <el-button size="small" @click="bindCancel">取 消</el-button>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    showFoot: {
      type: Boolean,
      default: true
    },
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    bindCancel () {
      let vm = this
      vm.$emit('cancel')
    },
    bindConfirm () {
      let vm = this
      vm.$emit('confirm')
    }
  }
}
</script>

<style lang="scss">
.no-head {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0px;
  }
}
</style>
<style lang="scss" scoped>
.pop-up {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: #00000060;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: left;
  .pop-up-content {
    max-height: 600px;
    overflow: auto;
    padding: 10px 0px;
  }
  .box-content {
    display: flex;
    flex-flow: column;
    background: #fff;
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    .pop-up-title {
      display: flex;
      padding: 16px;
      border-bottom: 1px solid #eeeeee;
      font-size: 16px;
      font-weight: 500;
    }
    .pop-up-content {
      flex: 1;
    }
    .pop-up-foot {
      display: flex;
      padding: 16px;
      text-align: right;
      border-top: 1px solid #eeeeee;
      .pop-up-foot-left {
        flex: 1;
      }
    }
  }
  .el-icon-close {
    cursor: pointer;
    &:hover {
      color: red;
    }
  }
}
</style>
